import React from 'react';
import { Avatar as AvatarCore, AvatarFallback, AvatarImage } from "./avatar";
export function Avatar(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    fallback = _ref.fallback;
  return /*#__PURE__*/React.createElement(AvatarCore, null, /*#__PURE__*/React.createElement(AvatarImage, {
    src: src,
    alt: alt
  }), fallback ? /*#__PURE__*/React.createElement(AvatarFallback, null, fallback) : null);
}